import { createApp } from 'vue'
import ScrollLink from './ScrollLink.vue'

createApp(ScrollLink).mount('#scroll-link')
